/* eslint-disable @next/next/no-img-element */
import React from 'react';

import classNames from 'classnames';

import NoUserImage from '@kamernet/assets/no-user-image.webp';
import { getImageUrl } from '@kamernet/utilities/Resources/getImageUrl';

import { handleUserImageError } from '../../utilities';

import styles from './UserProfileImage.module.css';

export interface UserProfileImageProps {
  width: number;
  height: number;
  imageKey: string | null | undefined;
  className?: string;
}

export const UserProfileImage = ({
  imageKey,
  width,
  height,
  className = undefined,
}: UserProfileImageProps) => {
  return (
    <img
      className={classNames(styles.root, className)}
      width={width}
      height={height}
      alt="user profile"
      src={
        getImageUrl(imageKey, { width: 150, height: 150 }) || NoUserImage.src
      }
      loading="lazy"
      onError={handleUserImageError}
    />
  );
};
